import { Controller } from '@hotwired/stimulus'

// Shows every sequence's recommendations at once, or one at a time with the
// stepper. Both are drawn, so which one shows is only a CSS state.
export default class extends Controller {
  toggle() {
    this.element.dataset.coachExpanded = String(this.element.dataset.coachExpanded !== 'true')
  }
}
